import React, { useLayoutEffect } from "react";
import { useMessageContext } from "../../../context/MessageContext/context";
import {
    focusOnMessage,
    selectCurrentUserId,
} from "../../../redux/slices";
import { useTypedDispatch, useTypedSelector } from "../../../redux/hooks";
import styles from "./Reply.module.scss";
import { MessageSender } from "../ChatMessages/ChatMessage/MessageSender";
import { MarkdownContainer } from "../../chatG/MarkdownComponents";
import { formatChatPreviewTime } from "../../../helpers";
import { selectMessageIds } from "../../../redux/slices/messageSlice";
import { useConversationContext } from "../../../context/ChatContext/contextConvo";

interface Props {
    input?: boolean;
    scrollToBottom?: (val: 'smooth' | 'auto') => void;
}

export const ReplyPlaceholder: React.FC<{ input?: boolean }> = ({ input }) => (
    <div
        className={styles.reply_container}
        data-is-input={!!input}
        data-placeholder="true"
        aria-hidden
    >
        <span className={styles.vertical_line} />
    </div>
);

const Reply: React.FC<Props> = ({ input, scrollToBottom }) => {
    const { message } = useMessageContext();
    const { conversation } = useConversationContext();

    const messageIdsLength = useTypedSelector(state => selectMessageIds(state, conversation.uuid, conversation.is_search ? 'search' : 'initial'))?.length
    const userUuid = useTypedSelector(selectCurrentUserId);

    const dispatch = useTypedDispatch();

    let parentChatId;
    switch (message.to_type) {
        case 'channel':
            parentChatId = message.to;
            break;
        case 'user':
            if (message?.to?.includes(userUuid)) {
                parentChatId = message.from;
            } else {
                parentChatId = message.to
            }
            break;
    }

    useLayoutEffect(() => {
        if (scrollToBottom && (messageIdsLength || 1) < 4) {
            scrollToBottom('auto')
        }
    }, []);

    const goToMessage = () => {
        dispatch(focusOnMessage({ chat_uuid: parentChatId, message }));
    }

    if (!message) {
        return null;
    }
    return (
        <div
            className={styles.reply_container}
            data-is-reply="true"
            onClick={() => goToMessage()}
            /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
            tabIndex={0}
            data-is-input={!!input}
        >
            <span className={styles.vertical_line} />
            <div>
                <MessageSender />
                <div
                    className={styles.message_content}

                >
                    <p data-date-space={!message.files ? formatChatPreviewTime(message.time || '') : null}>
                        {message.content ? (
                            <MarkdownContainer
                                plain
                            >
                                {message.content}
                            </MarkdownContainer>
                        ) : null}
                        {message.files ? (
                            <ul className={styles.attachments}>
                                {message.files.map(file => (
                                    <li
                                        key={`RF_${file.uuid}`}
                                    >
                                        <p>
                                            {file.name}
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        ) : null}
                    </p>
                </div>
                <div className={styles.status}>
                    <p>
                        {formatChatPreviewTime(message.time || '')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Reply;
